// Validation utility functions for form fields

export const validators = {
  // Required field validation
  required: (value, fieldName = 'This field') => {
    if (!value || value.toString().trim() === '') {
      return `${fieldName} is required`;
    }
    return '';
  },

  // South African phone number validation
  phone: (value) => {
    if (!value) return '';
    
    // Remove spaces, dashes, and parentheses
    const cleaned = value.replace(/[\s\-()]/g, '');
    
    // Check for valid SA phone formats:
    // 10 digits starting with 0: 0821234567
    // With country code: +27821234567 or 27821234567
    const saPhoneRegex = /^(\+27|27|0)[6-8][0-9]{8}$/;
    
    if (!saPhoneRegex.test(cleaned)) {
      return 'Please enter a valid South African phone number';
    }
    return '';
  },

  // Email validation
  email: (value) => {
    if (!value) return '';
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return 'Please enter a valid email address';
    }
    return '';
  },

  // Name validation (letters, spaces, hyphens, apostrophes only)
  name: (value) => {
    if (!value) return '';
    
    const nameRegex = /^[a-zA-Z\s\-']+$/;
    if (!nameRegex.test(value)) {
      return 'Name should contain only letters, spaces, hyphens, and apostrophes';
    }
    return '';
  },

  // Minimum length validation
  minLength: (value, min, fieldName = 'This field') => {
    if (!value) return '';
    
    if (value.length < min) {
      return `${fieldName} must be at least ${min} characters`;
    }
    return '';
  },

  // South African postal code validation (4 digits)
  postalCode: (value) => {
    if (!value) return '';
    
    const postalRegex = /^\d{4}$/;
    if (!postalRegex.test(value)) {
      return 'Postal code must be 4 digits';
    }
    return '';
  },

  // Date validation (must be today or future)
  futureDate: (value) => {
    if (!value) return '';
    
    const selectedDate = new Date(value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (selectedDate < today) {
      return 'Collection date must be today or in the future';
    }
    return '';
  },

  // Address validation (minimum length)
  address: (value) => {
    if (!value) return '';
    
    if (value.trim().length < 5) {
      return 'Please enter a complete address (at least 5 characters)';
    }
    return '';
  },
};

// Validate a single field with multiple validators
export const validateField = (value, validationRules) => {
  for (const rule of validationRules) {
    const error = rule(value);
    if (error) {
      return error;
    }
  }
  return '';
};

// Validate entire form
export const validateForm = (formData, validationSchema) => {
  const errors = {};
  let isValid = true;

  Object.keys(validationSchema).forEach((fieldName) => {
    const value = formData[fieldName];
    const rules = validationSchema[fieldName];
    const error = validateField(value, rules);
    
    if (error) {
      errors[fieldName] = error;
      isValid = false;
    }
  });

  return { errors, isValid };
};
